import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const AdminDashboard = lazy(() => import('../pages/admin/AdminDashboard'));
const AdminSettings = lazy(() => import('../pages/admin/AdminSettings'));
const AdminHealth = lazy(() => import('../pages/admin/AdminHealth'));
const AdminUsers = lazy(() => import('../pages/admin/AdminUsers'));
const AdminAuditLog = lazy(() => import('../pages/admin/AdminAuditLog'));
const AdminSecurityConfig = lazy(() => import('../pages/admin/AdminSecurityConfig'));
const AdminDbBackup = lazy(() => import('../pages/admin/AdminDbBackup'));
const AdminDocs = lazy(() => import('../pages/admin/AdminDocs'));
const AdminArticles = lazy(() => import('../pages/admin/AdminArticles'));
const AdminArticleEdit = lazy(() => import('../pages/admin/AdminArticleEdit'));
const AdminEditBySlug = lazy(() => import('../pages/admin/AdminEditBySlug'));
const AdminSponsoredOrders = lazy(() => import('../pages/admin/AdminSponsoredOrders'));
const AdminLLMUsageReport = lazy(() => import('../pages/admin/AdminLLMUsageReport'));
const AdminAIPromptCenter = lazy(() => import('../pages/admin/AdminAIPromptCenter'));
const AdminErrorLog = lazy(() => import('../pages/admin/AdminErrorLog'));
const AdminFeeds = lazy(() => import('../pages/admin/AdminFeeds'));
const AdminComments = lazy(() => import('../pages/admin/AdminComments'));
const AdminPages = lazy(() => import('../pages/admin/AdminPages'));
const AdminMedia = lazy(() => import('../pages/admin/AdminMedia'));
const AdminCategories = lazy(() => import('../pages/admin/AdminCategories'));
const AdminImport = lazy(() => import('../pages/admin/AdminImport'));
const AdminBlog = lazy(() => import('../pages/admin/AdminBlog'));
const AdminSeries = lazy(() => import('../pages/admin/AdminSeries'));
const AdminAuthors = lazy(() => import('../pages/admin/AdminAuthors'));
const AdminTranslations = lazy(() => import('../pages/admin/AdminTranslations'));
const AdminBulkOperations = lazy(() => import('../pages/admin/AdminBulkOperations'));
const AdminEditorialWorkflow = lazy(() => import('../pages/admin/AdminEditorialWorkflow'));
const AdminContentScheduler = lazy(() => import('../pages/admin/AdminContentScheduler'));
const AdminContentCalendar = lazy(() => import('../pages/admin/AdminContentCalendar'));
const AdminVersioning = lazy(() => import('../pages/admin/AdminVersioning'));
const AdminSanitization = lazy(() => import('../pages/admin/AdminSanitization'));
const AdminUGCReview = lazy(() => import('../pages/admin/AdminUGCReview'));
const AdminBreakingNews = lazy(() => import('../pages/admin/AdminBreakingNews'));
const AdminAnalytics = lazy(() => import('../pages/admin/AdminAnalytics'));
const AdminAdvancedAnalytics = lazy(() => import('../pages/admin/AdminAdvancedAnalytics'));
const AdminLiveAnalytics = lazy(() => import('../pages/admin/AdminLiveAnalytics'));
const AdminHeatmaps = lazy(() => import('../pages/admin/AdminHeatmaps'));
const AdminVisitorMap = lazy(() => import('../pages/admin/AdminVisitorMap'));
const AdminReports = lazy(() => import('../pages/admin/AdminReports'));
const AdminPlatformAudit = lazy(() => import('../pages/admin/AdminPlatformAudit'));
const AdminPerformanceForecast = lazy(() => import('../pages/admin/AdminPerformanceForecast'));
const AdminCompetitorMonitoring = lazy(() => import('../pages/admin/AdminCompetitorMonitoring'));
const AdminChurnPrediction = lazy(() => import('../pages/admin/AdminChurnPrediction'));
const AdminDuplicateDetection = lazy(() => import('../pages/admin/AdminDuplicateDetection'));
const AdminABTesting = lazy(() => import('../pages/admin/AdminABTesting'));
const AdminSubscriptions = lazy(() => import('../pages/admin/AdminSubscriptions'));
const AdminPayments = lazy(() => import('../pages/admin/AdminPayments'));
const AdminInvoices = lazy(() => import('../pages/admin/AdminInvoices'));
const AdminDynamicPricing = lazy(() => import('../pages/admin/AdminDynamicPricing'));
const AdminPromoCodes = lazy(() => import('../pages/admin/AdminPromoCodes'));
const AdminVouchers = lazy(() => import('../pages/admin/AdminVouchers'));
const AdminTips = lazy(() => import('../pages/admin/AdminTips'));
const AdminMonetization = lazy(() => import('../pages/admin/AdminMonetization'));
const AdminSponsoredArticles = lazy(() => import('../pages/admin/AdminSponsoredArticles'));
const AdminSponsoredMarketplace = lazy(() => import('../pages/admin/AdminSponsoredMarketplace'));
const AdminAffiliates = lazy(() => import('../pages/admin/AdminAffiliates'));
const AdminSocial = lazy(() => import('../pages/admin/AdminSocial'));
const AdminSocialScheduler = lazy(() => import('../pages/admin/AdminSocialScheduler'));
const AdminNewsletter = lazy(() => import('../pages/admin/AdminNewsletter'));
const AdminNewsletterDigest = lazy(() => import('../pages/admin/AdminNewsletterDigest'));
const AdminEmailCampaigns = lazy(() => import('../pages/admin/AdminEmailCampaigns'));
const AdminPushNotifications = lazy(() => import('../pages/admin/AdminPushNotifications'));
const AdminLandingPages = lazy(() => import('../pages/admin/AdminLandingPages'));
const AdminBranding = lazy(() => import('../pages/admin/AdminBranding'));
const AdminSyndication = lazy(() => import('../pages/admin/AdminSyndication'));
const AdminAds = lazy(() => import('../pages/admin/AdminAds'));
const AdminAdsReport = lazy(() => import('../pages/admin/AdminAdsReport'));
const AdminAdSense = lazy(() => import('../pages/admin/AdminAdSense'));
const AdminAIContent = lazy(() => import('../pages/admin/AdminAIContent'));
const AdminRecommendations = lazy(() => import('../pages/admin/AdminRecommendations'));
const AdminSEODashboard = lazy(() => import('../pages/admin/AdminSEODashboard'));
const AdminAMP = lazy(() => import('../pages/admin/AdminAMP'));
const AdminSurveys = lazy(() => import('../pages/admin/AdminSurveys'));
const AdminWidgets = lazy(() => import('../pages/admin/AdminWidgets'));
const AdminJobs = lazy(() => import('../pages/admin/AdminJobs'));
const AdminClassifieds = lazy(() => import('../pages/admin/AdminClassifieds'));
const AdminVibePosao = lazy(() => import('../pages/admin/AdminVibePosao'));
const AdminHighLeads = lazy(() => import('../pages/admin/AdminHighLeads'));
const AdminChatSessions = lazy(() => import('../pages/admin/AdminChatSessions'));
const AdminServiceRequests = lazy(() => import('../pages/admin/AdminServiceRequests'));
const AdminQuizzes = lazy(() => import('../pages/admin/AdminQuizzes'));
const AdminCrypto = lazy(() => import('../pages/admin/AdminCrypto'));
const AdminPortalToggle = lazy(() => import('../pages/admin/AdminPortalToggle'));
const AdminDoktorEarnings = lazy(() => import('../pages/admin/AdminDoktorEarnings'));
const AdminMenuManager = lazy(() => import('../pages/admin/AdminMenuManager'));
const AdminMicropayments = lazy(() => import('../pages/admin/AdminMicropayments'));
const AdminPhotoVerification = lazy(() => import('../pages/admin/AdminPhotoVerification'));
const AdminCountyMap = lazy(() => import('../pages/admin/AdminCountyMap'));
const AdminTimesBrands = lazy(() => import('../pages/admin/AdminTimesBrands'));
const AdminBreakingExpiry = lazy(() => import('../pages/admin/AdminBreakingExpiry'));
const AdminAdManagement = lazy(() => import('../pages/admin/AdminAdManagement'));
const AdminLLMUsage = lazy(() => import('../pages/admin/AdminLLMUsage'));
const AdminTuzibaba = lazy(() => import('../pages/admin/AdminTuzibaba'));
const AdminPonuda = lazy(() => import('../pages/admin/AdminPonuda'));
const AdminFooterPartners = lazy(() => import('../pages/admin/AdminFooterPartners'));
const AdminPolls = lazy(() => import('../pages/admin/AdminPolls'));
const AdminHeroSettings = lazy(() => import('../pages/admin/AdminHeroSettings'));
const AdminStreams = lazy(() => import('../pages/admin/AdminStreams'));
const AdminAdvertiseAnalytics = lazy(() => import('../pages/admin/AdminAdvertiseAnalytics'));
const AdminImprint = lazy(() => import('../pages/admin/AdminImprint'));
const AdminContentHealth = lazy(() => import('../pages/admin/AdminContentHealth'));
const AdminAMPAnalyzer = lazy(() => import('../pages/admin/AdminAMPAnalyzer'));
const AdminTop10Weekly = lazy(() => import('../pages/admin/AdminTop10Weekly'));
const AdminMediaMigration = lazy(() => import('../pages/admin/AdminMediaMigration'));
const AdminI18nManager = lazy(() => import('../pages/admin/AdminI18nManager'));

export default function adminRoutes(AdminRoute) {
  return (
    <>
      {/* Core */}
      <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/settings" element={<AdminRoute><AdminSettings /></AdminRoute>} />
      <Route path="/admin/health" element={<AdminRoute><AdminHealth /></AdminRoute>} />
      <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
      <Route path="/admin/audit-log" element={<AdminRoute><AdminAuditLog /></AdminRoute>} />
      <Route path="/admin/security" element={<AdminRoute><AdminSecurityConfig /></AdminRoute>} />
      <Route path="/admin/db-backup" element={<AdminRoute><AdminDbBackup /></AdminRoute>} />
      <Route path="/admin/docs" element={<AdminRoute><AdminDocs /></AdminRoute>} />

      {/* Content */}
      <Route path="/admin/articles" element={<AdminRoute><AdminArticles /></AdminRoute>} />
      <Route path="/admin/articles/new" element={<AdminRoute><AdminArticleEdit /></AdminRoute>} />
      <Route path="/admin/articles/edit/:id" element={<AdminRoute><AdminArticleEdit /></AdminRoute>} />
      <Route path="/admin/articles/edit-by-slug/:slug" element={<AdminRoute><AdminEditBySlug /></AdminRoute>} />
      <Route path="/admin/sponsored-orders" element={<AdminRoute><AdminSponsoredOrders /></AdminRoute>} />
      <Route path="/admin/llm-usage-report" element={<AdminRoute><AdminLLMUsageReport /></AdminRoute>} />
      <Route path="/admin/ai-prompt-center" element={<AdminRoute><AdminAIPromptCenter /></AdminRoute>} />
      <Route path="/admin/error-log" element={<AdminRoute><AdminErrorLog /></AdminRoute>} />
      <Route path="/admin/feeds" element={<AdminRoute><AdminFeeds /></AdminRoute>} />
      <Route path="/admin/comments" element={<AdminRoute><AdminComments /></AdminRoute>} />
      <Route path="/admin/pages" element={<AdminRoute><AdminPages /></AdminRoute>} />
      <Route path="/admin/media" element={<AdminRoute><AdminMedia /></AdminRoute>} />
      <Route path="/admin/categories" element={<AdminRoute><AdminCategories /></AdminRoute>} />
      <Route path="/admin/import" element={<AdminRoute><AdminImport /></AdminRoute>} />
      <Route path="/admin/blog" element={<AdminRoute><AdminBlog /></AdminRoute>} />
      <Route path="/admin/series" element={<AdminRoute><AdminSeries /></AdminRoute>} />
      <Route path="/admin/authors" element={<AdminRoute><AdminAuthors /></AdminRoute>} />
      <Route path="/admin/translations" element={<AdminRoute><AdminTranslations /></AdminRoute>} />
      <Route path="/admin/bulk-operations" element={<AdminRoute><AdminBulkOperations /></AdminRoute>} />
      <Route path="/admin/editorial-workflow" element={<AdminRoute><AdminEditorialWorkflow /></AdminRoute>} />
      <Route path="/admin/scheduler" element={<AdminRoute><AdminContentScheduler /></AdminRoute>} />
      <Route path="/admin/content-calendar" element={<AdminRoute><AdminContentCalendar /></AdminRoute>} />
      <Route path="/admin/versioning" element={<AdminRoute><AdminVersioning /></AdminRoute>} />
      <Route path="/admin/sanitization" element={<AdminRoute><AdminSanitization /></AdminRoute>} />
      <Route path="/admin/ugc-review" element={<AdminRoute><AdminUGCReview /></AdminRoute>} />
      <Route path="/admin/breaking-news" element={<AdminRoute><AdminBreakingNews /></AdminRoute>} />

      {/* Analytics */}
      <Route path="/admin/analytics" element={<AdminRoute><AdminAnalytics /></AdminRoute>} />
      <Route path="/admin/advanced-analytics" element={<AdminRoute><AdminAdvancedAnalytics /></AdminRoute>} />
      <Route path="/admin/live-analytics" element={<AdminRoute><AdminLiveAnalytics /></AdminRoute>} />
      <Route path="/admin/heatmaps" element={<AdminRoute><AdminHeatmaps /></AdminRoute>} />
      <Route path="/admin/visitor-map" element={<AdminRoute><AdminVisitorMap /></AdminRoute>} />
      <Route path="/admin/reports" element={<AdminRoute><AdminReports /></AdminRoute>} />
      <Route path="/admin/platform-audit" element={<AdminRoute><AdminPlatformAudit /></AdminRoute>} />
      <Route path="/admin/performance-forecast" element={<AdminRoute><AdminPerformanceForecast /></AdminRoute>} />
      <Route path="/admin/competitor-monitoring" element={<AdminRoute><AdminCompetitorMonitoring /></AdminRoute>} />
      <Route path="/admin/churn-prediction" element={<AdminRoute><AdminChurnPrediction /></AdminRoute>} />
      <Route path="/admin/duplicate-detection" element={<AdminRoute><AdminDuplicateDetection /></AdminRoute>} />
      <Route path="/admin/ab-testing" element={<AdminRoute><AdminABTesting /></AdminRoute>} />

      {/* Monetization */}
      <Route path="/admin/subscriptions" element={<AdminRoute><AdminSubscriptions /></AdminRoute>} />
      <Route path="/admin/payments" element={<AdminRoute><AdminPayments /></AdminRoute>} />
      <Route path="/admin/invoices" element={<AdminRoute><AdminInvoices /></AdminRoute>} />
      <Route path="/admin/pricing" element={<AdminRoute><AdminDynamicPricing /></AdminRoute>} />
      <Route path="/admin/promo-codes" element={<AdminRoute><AdminPromoCodes /></AdminRoute>} />
      <Route path="/admin/vouchers" element={<AdminRoute><AdminVouchers /></AdminRoute>} />
      <Route path="/admin/tips" element={<AdminRoute><AdminTips /></AdminRoute>} />
      <Route path="/admin/monetization" element={<AdminRoute><AdminMonetization /></AdminRoute>} />
      <Route path="/admin/sponsored" element={<AdminRoute><AdminSponsoredArticles /></AdminRoute>} />
      <Route path="/admin/sponsored-marketplace" element={<AdminRoute><AdminSponsoredMarketplace /></AdminRoute>} />
      <Route path="/admin/affiliates" element={<AdminRoute><AdminAffiliates /></AdminRoute>} />

      {/* Marketing */}
      <Route path="/admin/social" element={<AdminRoute><AdminSocial /></AdminRoute>} />
      <Route path="/admin/social-scheduler" element={<AdminRoute><AdminSocialScheduler /></AdminRoute>} />
      <Route path="/admin/newsletter" element={<AdminRoute><AdminNewsletter /></AdminRoute>} />
      <Route path="/admin/newsletter-digest" element={<AdminRoute><AdminNewsletterDigest /></AdminRoute>} />
      <Route path="/admin/email-campaigns" element={<AdminRoute><AdminEmailCampaigns /></AdminRoute>} />
      <Route path="/admin/push-notifications" element={<AdminRoute><AdminPushNotifications /></AdminRoute>} />
      <Route path="/admin/landing-pages" element={<AdminRoute><AdminLandingPages /></AdminRoute>} />
      <Route path="/admin/branding" element={<AdminRoute><AdminBranding /></AdminRoute>} />
      <Route path="/admin/syndication" element={<AdminRoute><AdminSyndication /></AdminRoute>} />

      {/* Advertising */}
      <Route path="/admin/ads" element={<AdminRoute><AdminAds /></AdminRoute>} />
      <Route path="/admin/ads-report" element={<AdminRoute><AdminAdsReport /></AdminRoute>} />
      <Route path="/admin/adsense" element={<AdminRoute><AdminAdSense /></AdminRoute>} />

      {/* AI & Smart Features */}
      <Route path="/admin/ai-content" element={<AdminRoute><AdminAIContent /></AdminRoute>} />
      <Route path="/admin/recommendations" element={<AdminRoute><AdminRecommendations /></AdminRoute>} />
      <Route path="/admin/seo-dashboard" element={<AdminRoute><AdminSEODashboard /></AdminRoute>} />
      <Route path="/admin/amp" element={<AdminRoute><AdminAMP /></AdminRoute>} />

      {/* Specialized */}
      <Route path="/admin/surveys" element={<AdminRoute><AdminSurveys /></AdminRoute>} />
      <Route path="/admin/widgets" element={<AdminRoute><AdminWidgets /></AdminRoute>} />
      <Route path="/admin/jobs" element={<AdminRoute><AdminJobs /></AdminRoute>} />
      <Route path="/admin/classifieds" element={<AdminRoute><AdminClassifieds /></AdminRoute>} />
      <Route path="/admin/vibeposao" element={<AdminRoute><AdminVibePosao /></AdminRoute>} />
      <Route path="/admin/high-leads" element={<AdminRoute><AdminHighLeads /></AdminRoute>} />
      <Route path="/admin/chat-sessions" element={<AdminRoute><AdminChatSessions /></AdminRoute>} />
      <Route path="/admin/service-requests" element={<AdminRoute><AdminServiceRequests /></AdminRoute>} />
      <Route path="/admin/quizzes" element={<AdminRoute><AdminQuizzes /></AdminRoute>} />
      <Route path="/admin/crypto" element={<AdminRoute><AdminCrypto /></AdminRoute>} />
      <Route path="/admin/portal-toggle" element={<AdminRoute><AdminPortalToggle /></AdminRoute>} />
      <Route path="/admin/doktor-earnings" element={<AdminRoute><AdminDoktorEarnings /></AdminRoute>} />
      <Route path="/admin/menu-manager" element={<AdminRoute><AdminMenuManager /></AdminRoute>} />
      <Route path="/admin/micropayments" element={<AdminRoute><AdminMicropayments /></AdminRoute>} />
      <Route path="/admin/photo-verification" element={<AdminRoute><AdminPhotoVerification /></AdminRoute>} />
      <Route path="/admin/county-map" element={<AdminRoute><AdminCountyMap /></AdminRoute>} />
      <Route path="/admin/times-brands" element={<AdminRoute><AdminTimesBrands /></AdminRoute>} />
      <Route path="/admin/breaking-expiry" element={<AdminRoute><AdminBreakingExpiry /></AdminRoute>} />
      <Route path="/admin/ad-management" element={<AdminRoute><AdminAdManagement /></AdminRoute>} />
      <Route path="/admin/llm-usage" element={<AdminRoute><AdminLLMUsage /></AdminRoute>} />
      <Route path="/admin/tuzibaba" element={<AdminRoute><AdminTuzibaba /></AdminRoute>} />
      <Route path="/admin/ponuda" element={<AdminRoute><AdminPonuda /></AdminRoute>} />
      <Route path="/admin/footer-partners" element={<AdminRoute><AdminFooterPartners /></AdminRoute>} />
      <Route path="/admin/polls" element={<AdminRoute><AdminPolls /></AdminRoute>} />
      <Route path="/admin/hero-settings" element={<AdminRoute><AdminHeroSettings /></AdminRoute>} />
      <Route path="/admin/streams" element={<AdminRoute><AdminStreams /></AdminRoute>} />
      <Route path="/admin/advertise-analytics" element={<AdminRoute><AdminAdvertiseAnalytics /></AdminRoute>} />
      <Route path="/admin/imprint" element={<AdminRoute><AdminImprint /></AdminRoute>} />
      <Route path="/admin/content-health" element={<AdminRoute><AdminContentHealth /></AdminRoute>} />
      <Route path="/admin/amp-analyzer" element={<AdminRoute><AdminAMPAnalyzer /></AdminRoute>} />
      <Route path="/admin/top10-weekly" element={<AdminRoute><AdminTop10Weekly /></AdminRoute>} />
      <Route path="/admin/media-migration" element={<AdminRoute><AdminMediaMigration /></AdminRoute>} />
      <Route path="/admin/i18n-manager" element={<AdminRoute><AdminI18nManager /></AdminRoute>} />
    </>
  );
}
